import { Component, Input } from "@angular/core";

@Component({
  selector: "able-loading",
  templateUrl: "./able-loading.component.html",
})
export class AbleLoadingComponent {
  @Input() showLoading: boolean = false;
  @Input() messageToDisplay: string;
}
